import React from 'react';
import PendingImage from 'images/pending-page.png';
import Header from 'components/Header';
import Navigation from 'components/Navigation';

const PendingPage = () => {
  return (
    <div>
      <Header
        isLoggedIn={false}
        history={history}
      />
      <Navigation
        isLoggedIn={false}
        modules={[]}
        allowModules={[]}
        isAdmin={false}
      />
      <div className="main-container">
        <div className={'container'}>
          <img src={PendingImage}/>
        </div>
      </div>
    </div>
  );
};

export default PendingPage;



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/components/PendingPage.js
 **/